export default __webpack_public_path__ + "static/media/adhoc.3c900637.png";